/* FCC product page (Flooring Cash and Carry, Oct 2026). No dependencies.
   Works around the room / carpet calculators without changing them:
   - it only LISTENS to the calculator's "price-update" event (detail.price, detail.packsNeeded)
   - it never reuses the calculators' class names or ids
   Features:
   - Delivery dates (weekend orders start Monday; working days from data-delivery-earliest/latest)
   - Click & Collect / Home delivery choice, saved as the cart attribute "Preferred fulfilment"
   - Free-delivery progress bar: trolley total + calculator total (or the product price on non-calculator pages)
   - Promise line under the Add to cart button
   - Sticky bar: "Calculate & add" scrolls to the calculator; once packs are worked out it presses the
     calculator's own Add to cart button (same as the customer clicking it). */
(function () {
  if (window.__fccPdp) return;
  window.__fccPdp = true;

  var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var D = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var data = { threshold: 49500, price: 0 };
  try { data = JSON.parse(document.getElementById('fcc-pdp-data').textContent); } catch (e) {}
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Dates ---------- */
  function start() {
    var d = new Date(); d.setHours(0, 0, 0, 0);
    if (d.getDay() === 6) d.setDate(d.getDate() + 2); else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function add(s, n) {
    var d = new Date(s), a = 0;
    while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; }
    return d;
  }
  function fmt(a, b) {
    if (a.getTime() === b.getTime()) return D[a.getDay()] + ' ' + a.getDate() + ' ' + M[a.getMonth()];
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + M[b.getMonth()];
    return a.getDate() + ' ' + M[a.getMonth()] + ' – ' + b.getDate() + ' ' + M[b.getMonth()];
  }
  function fillDates() {
    var s = start();
    document.querySelectorAll('[data-fcc-pdp-delivery]:not([data-fcc-done])').forEach(function (el) {
      var e = parseInt(el.getAttribute('data-delivery-earliest'), 10) || 2;
      var l = Math.max(parseInt(el.getAttribute('data-delivery-latest'), 10) || e, e);
      if (el.hasAttribute('data-fcc-single')) l = e;
      var t = el.querySelector('[data-fcc-pdp-dates]');
      if (t) t.textContent = (t.getAttribute('data-prefix') || '') + fmt(add(s, e), add(s, l));
      el.setAttribute('data-fcc-done', '');
    });
  }

  function money(pence) { return '£' + (pence / 100).toFixed(2); }
  function calcEl() { return document.querySelector('room-calculator, carpet-calculator'); }
  function isCarpetCalc() { var c = calcEl(); return !!c && c.tagName === 'CARPET-CALCULATOR'; }
  function quoteEl() { return document.getElementById('quote-calculator'); }
  function addButton() {
    var c = calcEl();
    var b = c && c.querySelector('button[type="submit"], button.button');
    if (!b && c) b = c.parentElement && c.parentElement.querySelector('room-calculator button.button, carpet-calculator button.button');
    return b || document.querySelector('.product__info-container .product-form__submit');
  }

  /* ---------- Fulfilment choice ---------- */
  function initFulfil() {
    var radios = document.querySelectorAll('input[name="fcc-fulfil"]');
    function mark() { radios.forEach(function (r) { var row = r.closest('.fcc-avail__row'); if (row) row.classList.toggle('is-on', r.checked); }); }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        mark();
        try {
          fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Preferred fulfilment': r.value } }) });
        } catch (e) {}
      });
    });
    mark();
  }

  /* ---------- Free-delivery bar ---------- */
  var cartTotal = null, calcTotal = 0, calcPacks = 0, calcArea = 0;
  function loadCart() {
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price || 0; updateFree(); })
      .catch(function () { cartTotal = 0; updateFree(); });
  }
  function updateFree() {
    var el = document.querySelector('[data-fcc-free]');
    if (!el || cartTotal === null) return;
    var thisItem = calcEl() ? calcTotal : (quoteEl() ? 0 : (data.price || 0));
    var total = cartTotal + thisItem;
    var left = data.threshold - total;
    var pct = Math.min(100, Math.round(total / data.threshold * 100));
    var html = left > 0
      ? 'Add <b>' + money(left) + '</b> more for <b>free delivery</b><span class="fcc-avail__bar"><span style="width:' + pct + '%"></span></span>'
      : '<b class="fcc-avail__ok">✓ Free delivery</b> on this order<span class="fcc-avail__bar"><span style="width:100%"></span></span>';
    if (el.getAttribute('data-h') !== html) { el.innerHTML = html; el.setAttribute('data-h', html); }
    el.hidden = false;
  }

  /* ---------- Promise line under Add to cart ---------- */
  function promise() {
    var btn = addButton();
    if (!btn || document.querySelector('.fcc-atc-promise')) return;
    var parts = [];
    var stock = document.querySelector('.fcc-avail--stock');
    var del = document.querySelector('[data-fcc-delivery-row] [data-fcc-pdp-dates]');
    if (stock) parts.push('Collect today');
    if (del) parts.push((stock ? 'or delivered ' : 'Ordered in for you · delivered ') + del.textContent);
    if (!parts.length) return;
    var p = document.createElement('p');
    p.className = 'fcc-atc-promise';
    p.textContent = parts.join(', ');
    btn.insertAdjacentElement('afterend', p);
  }

  /* ---------- Sticky bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-fcc-sticky]');
    if (!bar) return;
    document.body.appendChild(bar);
    bar.hidden = false;
    var btn = bar.querySelector('[data-fcc-sticky-btn]');
    if (!calcEl()) btn.textContent = quoteEl() ? 'Get my quote' : 'Add to cart';
    var ticking = false;
    function check() {
      ticking = false;
      var target = calcEl() || quoteEl() || addButton();
      var past = !!target && target.getBoundingClientRect().bottom < 0;
      if (bar.classList.contains('is-shown') !== past) bar.classList.toggle('is-shown', past);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    check();
    btn.addEventListener('click', function () {
      var c = calcEl();
      if (c && calcPacks > 0) { var b = addButton(); if (b && !b.disabled) b.click(); return; }
      if (c) {
        c.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { var i = c.querySelector('input[type="number"], input[type="text"]'); if (i) i.focus({ preventScroll: true }); }, 450);
        return;
      }
      var q = quoteEl();
      if (q) { q.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var s = addButton();
      if (s && !s.disabled) s.click();
    });
  }
  function updateSticky() {
    var bar = document.querySelector('[data-fcc-sticky]');
    if (!bar || !calcEl()) return;
    var btn = bar.querySelector('[data-fcc-sticky-btn]');
    var price = bar.querySelector('[data-fcc-sticky-price]');
    var sub = bar.querySelector('[data-fcc-sticky-sub]');
    if (!sub.hasAttribute('data-orig')) sub.setAttribute('data-orig', sub.textContent);
    if (!price.hasAttribute('data-orig')) price.setAttribute('data-orig', price.textContent);
    if (calcPacks > 0) {
      btn.textContent = 'Add to cart';
      price.textContent = money(calcTotal);
      sub.textContent = isCarpetCalc() ? (calcArea || calcPacks) + ' m²' : calcPacks + (calcPacks === 1 ? ' pack' : ' packs');
    } else {
      btn.textContent = 'Calculate & add';
      price.textContent = price.getAttribute('data-orig');
      sub.textContent = sub.getAttribute('data-orig');
    }
  }

  /* ---------- Listen (only) to the calculator ---------- */
  window.addEventListener('price-update', function (e) {
    var d = (e && e.detail) || {};
    var price = parseFloat(d.price) || 0;
    calcTotal = Math.round(price * 100);
    /* carpet calculator: packsNeeded is the m² quantity and can have decimals */
    calcPacks = isCarpetCalc() ? (parseFloat(d.packsNeeded) || 0) : (parseInt(d.packsNeeded, 10) || 0);
    calcArea = Math.round((parseFloat(d.totalArea) || 0) * 100) / 100;
    if (!price) { calcPacks = 0; calcArea = 0; }
    updateFree();
    updateSticky();
  });

  function init() {
    fillDates();
    initFulfil();
    loadCart();
    promise();
    initSticky();
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, loadCart); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
